export enum PassDetailPanels {
  Summary = 'summary',
  Punches = 'punches',
  Schedule = 'schedule',
  PersonalDetails = 'personal_details',
  Management = 'management',
  Billing = 'billing',
  CommunicationTracking = 'communication_tracking',
  ActivityLog = 'activity_log',
  AllOpen = 'all_open',
}

export type EditPassFormValues = {
  firstname: string;
  lastname: string;
  alternative_full_name: string;
  email: string;
  phone: string;
  price: number;
  expiration_date: string;
  start_date: string;
  comment: string;
  permanent_schedule_hold: boolean;
};
